import { Product } from '../types';
import { Analytics } from '..';

export type WishListListName = 'Search' | 'Details' | '';

export default function wishList(self: Analytics) {
    return {
        add(listName: WishListListName = '', product: Product) {
            self.DataLayerEvent({
                action: 'Added',
                category: ['Wishlist', listName].filter(Boolean).join(' - '),
                label: `SKU = ${product.id}`,
                nonInteraction: true,
            });
            self.fbq('track', 'AddToWishlist', {
                content_ids: product.id,
                content_category: product.category,
                content_name: product.name,
                content_type: 'product',
                product_catalog_id: 333969174115095,
            });
            return self;
        },
        remove(listName: WishListListName = '', product: Product) {
            self.DataLayerEvent({
                action: 'Removed',
                category: ['Wishlist', listName].filter(Boolean).join(' - '),
                label: `SKU = ${product.id}`,
                nonInteraction: true,
            });
            self.fbq('track', 'RemoveFromWishlist', {
                content_ids: product.id,
                content_category: product.category,
                content_name: product.name,
                content_type: 'product',
                product_catalog_id: 333969174115095,
            });
            return self;
        },
    };
}
